module.exports = __webpack_public_path__ + "media/thePool-2023.3aecfab8.mp4";